import { Ability } from "@casl/ability";

const ability = new Ability();
export { ability };

export default function defineAbilitiesFor(group) {
    switch (group) {
        case "ADM":
            return [
                // Home
                {
                    subject: "home",
                    action: [
                        "create",
                        "read",
                        "update",
                        "delete",
                        "readRegistrationsStatistics",
                    ],
                },
                // Registrations
                {
                    subject: "registrations",
                    action: [
                        "create",
                        "read",
                        "update",
                        "delete",
                        "finish",
                        "noShow",
                        "readDocks",
                        "readCompanies",
                        "readHandlingCharges",
                    ],
                },
                // Registrations Archive
                {
                    subject: "registrationsarchive",
                    action: [
                        "read",
                        "undo",
                        "readCompanies",
                        "readHandlingCharges",
                    ],
                },
                // Recurring Registrations
                {
                    subject: "recurringregistrations",
                    action: ["create", "read", "update", "delete"],
                },
                // Users
                {
                    subject: "users",
                    action: ["create", "read", "update", "delete"],
                },
                // Company
                {
                    subject: "company",
                    action: ["create", "read", "update", "delete"],
                },
                // Driver Registration
                {
                    subject: "driverregistration",
                    action: ["create", "read", "update", "delete"],
                },
                // Driver Overview
                {
                    subject: "driveroverview",
                    action: [
                        "create",
                        "read",
                        "update",
                        "delete",
                        "readDockNumber",
                        "updateDockNumber",
                    ],
                },
                // Backoffice remarks
                { subject: "backOfficeRemarks", action: ["access"] },
            ];
        case "BAC":
            return [
                {
                    // Home
                    subject: "home",
                    action: [
                        "create",
                        "read",
                        "update",
                        "delete",
                        "readRegistrationsStatistics",
                    ],
                },
                {
                    subject: "registrations",
                    action: [
                        "create",
                        "read",
                        "update",
                        "delete",
                        "finish",
                        "noShow",
                        "readDocks",
                        "readCompanies",
                        "readHandlingCharges",
                    ],
                },
                {
                    subject: "registrationsarchive",
                    action: [
                        "read",
                        "undo",
                        "readCompanies",
                        "readHandlingCharges",
                    ],
                },
                {
                    subject: "recurringregistrations",
                    action: ["create", "read", "update", "delete"],
                },
                {
                    subject: "driveroverview",
                    action: [
                        "create",
                        "read",
                        "update",
                        "delete",
                        "readDockNumber",
                        "updateDockNumber",
                    ],
                },
                { subject: "backOfficeRemarks", action: ["access"] },
            ];
        case "WAR":
            return [
                {
                    // Home
                    subject: "home",
                    action: [
                        "create",
                        "read",
                        "update",
                        "delete",
                        "readRegistrationsStatistics",
                    ],
                },
                // Driver Overview
                {
                    subject: "driveroverview",
                    action: ["read", "readDockNumber"],
                },
            ];
        case "FT2":
            return [
                {
                    subject: "home",
                    action: [
                        "create",
                        "read",
                        "update",
                        "delete",
                        "readRegistrationsStatistics",
                    ],
                },
                {
                    subject: "registrations",
                    action: ["create", "read", "update", "delete"],
                },
                {
                    subject: "recurringregistrations",
                    action: ["create", "read", "update", "delete"],
                },
                { subject: "registrationsarchive", action: ["read"] },
                { subject: "driveroverview", action: ["read"] },
            ];
        case "HUM":
            return [
                {
                    subject: "home",
                    action: [
                        "create",
                        "read",
                        "update",
                        "delete",
                        "readRegistrationsStatistics",
                    ],
                },
            ];
        case "LIS":
            return [
                {
                    subject: "home",
                    action: [
                        "create",
                        "read",
                        "update",
                        "delete",
                        "readRegistrationsStatistics",
                    ],
                },
            ];
        case "DRI":
            return [
                {
                    subject: "home",
                    action: ["create", "read", "update", "delete"],
                },
                { subject: "driverregistration", action: ["read"] },
            ];
        case "PER":
            return [
                {
                    subject: "home",
                    action: ["create", "read", "update", "delete"],
                },
                {
                    subject: "registrations",
                    action: [
                        "read",
                        "readHandlingCharges",
                        "updateHandlingCharges",
                        "readCompanies",
                    ],
                },
                {
                    subject: "registrationsarchive",
                    action: ["read", "readHandlingCharges"],
                },
            ];
        default:
            return [];
    }
}
